const $ = window.jQuery;
const $window = window.$window || $(window);


const MapPins = {


  init () {

    $('.pin .mini-icon').on('click', function(){
      var $this = $(this).parent();
      $('.pin').removeClass('open');
      if($this.hasClass('open')){
        $this.removeClass('open');
      }else{
        $this.addClass('open');
      }
      $this.find('.close').on('click', function(){
        $('.pin').removeClass('open');
      });
    });

    $('.list-item').on('click', function(){
      $('.pin').hide();
      $('.pin.'+$(this).attr('data-slug')).show();
    });
  
      
  
  }


};

export default MapPins;